import React, {useMemo} from 'react'
import {useSelector} from 'react-redux'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {orderStatus, orderStatusType, orderType, paymentStatus} from 'app/features/orders/models'
import {selectViewOrder} from 'app/features/orders/redux/order/orderSlice'
import {RootState} from 'setup'
import OrderActions from './OrderActions'
import {paymentStatusTypes} from 'app/constant'
import {isOrderPaymentFailed} from 'app/features/orders/models/EditOrderState'

interface Props {}
export const CancelOrder: React.FC<Props> = () => {
  const order = useSelector<RootState, ViewOrder>(selectViewOrder)

  const hidden = useMemo(() => {
    if (order.orderType === orderType.pos) {
      return !order.isAdminEnabledPosCancel
    }
    return (
      order.fulfillmentStatus === orderStatus.fulfilled ||
      order.fulfillmentStatus === orderStatus.restocked ||
      order.financialStatus === paymentStatus.failed ||
      order.financialStatus === paymentStatus.pending ||
      order.status === orderStatusType.migration
    )
  }, [
    order.financialStatus,
    order.fulfillmentStatus,
    order.isAdminEnabledPosCancel,
    order.orderType,
    order.status,
  ])

  if (
    order.fulfillmentStatus === orderStatus.restocked &&
    order.financialStatus === paymentStatusTypes.refunded
  ) {
    return null
  }

  if (isOrderPaymentFailed(order.financialStatus)) {
    return null
  }

  return <OrderActions hideRefundAndRestock={hidden} />
}

export default CancelOrder
